import { getPoolRole } from '../Components/Utils/utils';
import { internalApps } from '../Components/Utils/PoolConfig';

export const setUserPool = pool => {
	let internal = internalApps.includes(pool);
	return dispatch => {
		dispatch({ type: 'SET_USER_POOL', data: { userPool: pool, internalApp: internal } });
		if (pool === '') dispatch(setRoles(pool, []));
	};
};

export const setRoles = (pool, roles) => {
	return dispatch => {
		let poolName = pool === 'DS' ? 'DS_EN' : pool+'_';
		let poolRoles = poolName && roles ? getPoolRole(poolName, roles) : [];
		dispatch({ type: 'POOL_ROLE_ACCESS', data: { userPoolRoles: poolRoles } });
	};
};
